module.exports = __webpack_public_path__ + "static/media/ShulSpaceImage.cadbc4ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ShulSpaceImage.png
// module id = 989
// module chunks = 0